export default __webpack_public_path__ + "static/media/schultemix_locked_crown.23aca55a.svg";